// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"image_wrapper__LD9x5","image":"image_image__sPkwR"};